/* FAIRYDUST theme JS (v2 layout) */
(function(){
  /* prices in the store's own format (e.g. €30,00), not the browser's */
  var COMMA = /comma_separator/.test(window.FD_MONEY_FORMAT||'amount_with_comma_separator');
  var SYM = (function(){ try{ return (0).toLocaleString('en',{style:'currency',currency:window.FD_CURRENCY||'EUR',currencyDisplay:'narrowSymbol'}).replace(/[\d.,\s]/g,''); }catch(e){ return '€'; } })();
  var money = function(c){ var p=(Math.round(c)/100).toFixed(2).split('.'); var i=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,COMMA?'.':','); return SYM+i+(COMMA?',':'.')+p[1]; };
  var FREE_SHIP = (window.FD_FREE_SHIP||5000);
  function $(s,c){return (c||document).querySelector(s);}
  function $all(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Cart drawer ---------- */
  var lastFocus=null;
  function openDrawer(){ var d=$('#Drawer'); if(!d) return; lastFocus=document.activeElement; d.classList.add('is-on'); d.setAttribute('aria-hidden','false'); $('#Overlay')&&$('#Overlay').classList.add('is-on'); document.body.style.overflow='hidden'; renderCart(); setTimeout(function(){ var x=$('[data-cart-close]',d); x&&x.focus(); },50); }
  function closeDrawer(){ var d=$('#Drawer'); if(!d) return; d.classList.remove('is-on'); d.setAttribute('aria-hidden','true'); $('#Overlay')&&$('#Overlay').classList.remove('is-on'); document.body.style.overflow=''; if(lastFocus&&lastFocus.focus) lastFocus.focus(); }
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&$('#Drawer')&&$('#Drawer').classList.contains('is-on')) closeDrawer(); });

  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function cleanTitle(t){ return String(t||'').replace(/\s*\(made to order\)\s*/ig,' ').trim(); }
  function imgSize(u,w){ if(!u) return ''; if(u.indexOf('//')===0) u='https:'+u; return u + (u.indexOf('?')>-1?'&':'?') + 'width='+w; }
  var PLUS='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';

  function shipMsg(total){
    var pct=Math.min(100,Math.round(total/FREE_SHIP*100));
    var label= total>=FREE_SHIP ? 'Your order qualifies for <b>free standard shipping</b>.' : 'Add <b>'+money(FREE_SHIP-total)+'</b> more for <b>free standard shipping</b>.';
    return '<p>'+label+'</p><span class="fd-dship__bar"><span style="width:'+pct+'%"></span></span>';
  }

  function setCount(n){ $all('.cartcount').forEach(function(el){ el.textContent=n; el.hidden=!n; }); }

  function renderCart(){
    return fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      setCount(cart.item_count);
      var cnt=$('#DrawerCount'); if(cnt) cnt.textContent=cart.item_count?cart.item_count+(cart.item_count===1?' item':' items'):'';
      var ship=$('#DrawerShip'); if(ship){ ship.hidden=!cart.item_count; ship.innerHTML=shipMsg(cart.total_price); }
      var body=$('#DrawerBody'), foot=$('#DrawerFoot');
      if(!body) return;
      if(cart.item_count===0){
        body.innerHTML='<div class="fd-dempty"><p class="fd-dempty__t">Your bag is empty</p><p>Have a look around, there is a little magic for everyone.</p><div class="fd-pills"><a class="fd-pill fd-pill--fill" href="/collections/all-products">Shop all</a><a class="fd-pill" href="/collections/new-arrivals-1">New in</a></div></div>';
        if(foot) foot.hidden=true; return;
      }
      if(foot) foot.hidden=false;
      body.innerHTML='<ul class="fd-dlist">'+cart.items.map(function(it,i){
        var line=i+1, v=(it.variant_title&&it.variant_title!=='Default Title')?'<p class="fd-dline__v">'+esc(it.variant_title)+'</p>':'';
        var was=it.original_line_price>it.final_line_price?'<s>'+money(it.original_line_price)+'</s>':'';
        return '<li class="fd-dline">'+
          '<a class="fd-dline__img" href="'+esc(it.url)+'">'+(it.image?'<img src="'+esc(imgSize(it.image,200))+'" alt="" loading="lazy">':'')+'</a>'+
          '<div class="fd-dline__info">'+
            '<div class="fd-dline__top"><a class="fd-dline__t" href="'+esc(it.url)+'">'+esc(cleanTitle(it.product_title))+'</a><p class="fd-dline__p">'+was+money(it.final_line_price)+'</p></div>'+v+
            '<div class="fd-dline__ctrl">'+
              '<span class="fd-step"><button type="button" data-line-qty="'+line+':'+(it.quantity-1)+'" aria-label="One less">−</button><span>'+it.quantity+'</span><button type="button" data-line-qty="'+line+':'+(it.quantity+1)+'" aria-label="One more">+</button></span>'+
              '<button type="button" class="fd-dline__rm" data-line-qty="'+line+':0">Remove</button>'+
            '</div>'+
          '</div>'+
        '</li>';
      }).join('')+'</ul><div class="fd-dups" id="DrawerUpsell" hidden><p class="fd-dups__h">You may also like</p><div class="fd-dups__track" id="DrawerUpsellList"></div></div>';
      var sub=$('#DrawerSubtotal'); if(sub) sub.textContent=money(cart.total_price);
      var co=$('#DrawerCheckout'); if(co) co.innerHTML='Checkout – <b>'+money(cart.total_price)+'</b>';
      renderUpsell(cart);
    });
  }

  document.addEventListener('click',function(e){
    var q=e.target.closest('[data-line-qty]');
    if(!q) return;
    e.preventDefault();
    var parts=q.getAttribute('data-line-qty').split(':');
    var row=q.closest('.fd-dline'); if(row) row.classList.add('is-busy');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:parseInt(parts[0],10),quantity:Math.max(0,parseInt(parts[1],10))})})
      .then(function(r){return r.json();}).then(function(){ renderCart(); })
      .catch(function(){ if(row) row.classList.remove('is-busy'); });
  });

  var upsellCache={};
  function renderUpsell(cart){
    var wrap=$('#DrawerUpsell'), list=$('#DrawerUpsellList');
    if(!wrap||!list||!cart.items.length) return;
    var inCart={}; cart.items.forEach(function(i){inCart[i.product_id]=1;});
    var pid=cart.items[0].product_id;
    var get=function(intent){ var k=pid+intent; if(upsellCache[k]) return Promise.resolve(upsellCache[k]);
      return fetch('/recommendations/products.json?product_id='+pid+'&limit=8&intent='+intent).then(function(r){return r.json();}).then(function(d){ upsellCache[k]=d.products||[]; return upsellCache[k]; }).catch(function(){ return []; }); };
    get('complementary').then(function(a){ return a.length>=2?a:get('related').then(function(b){ return a.concat(b); }); })
      .then(function(all){
        var seen={}, items=all.filter(function(p){ if(inCart[p.id]||seen[p.id]||!p.available) return false; seen[p.id]=1; return true; }).slice(0,4);
        if(!items.length){ wrap.hidden=true; return; }
        list.innerHTML=items.map(function(p){
          var img=p.featured_image||(p.images&&p.images[0])||'';
          var single=p.variants&&p.variants.length===1;
          var btn=single?'<button type="button" class="fd-dup__add" data-quick-add="'+p.variants[0].id+'">'+PLUS+'<span>Add</span></button>':'<a class="fd-dup__add" href="'+esc(p.url)+'">'+PLUS+'<span>Choose</span></a>';
          return '<div class="fd-dup"><a class="fd-dup__img" href="'+esc(p.url)+'">'+(img?'<img src="'+esc(imgSize(img,240))+'" alt="">':'')+'</a>'+
            '<div class="fd-dup__info"><a class="fd-dup__t" href="'+esc(p.url)+'">'+esc(cleanTitle(p.title))+'</a><span class="fd-dup__p">'+(p.price_varies?'From ':'')+money(p.price)+'</span>'+btn+'</div></div>';
        }).join('');
        wrap.hidden=false;
      }).catch(function(){ wrap.hidden=true; });
  }

  /* product page: swap fallback cards for Shopify's own recommendations */
  $all('[data-recs-url]').forEach(function(w){
    var track=$('[data-recs-track]',w); if(!track) return;
    fetch(w.getAttribute('data-recs-url')).then(function(r){return r.text();}).then(function(html){
      var tmp=document.createElement('div'); tmp.innerHTML=html;
      var t=$('[data-recs-track]',tmp);
      if(t && t.children.length>=4){ track.innerHTML=t.innerHTML; track.scrollLeft=0; }
    }).catch(function(){});
  });

  window.fdRenderCart=renderCart; window.fdOpenCart=openDrawer;

  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-open]')){e.preventDefault();openDrawer();}
    if(e.target.closest('[data-cart-close]')||e.target.id==='Overlay'){closeDrawer(); closeNav();}
    var qa=e.target.closest('[data-quick-add]');
    if(qa){ e.preventDefault(); var id=qa.getAttribute('data-quick-add'); if(!id||qa.classList.contains('is-busy'))return;
      var t=qa.innerHTML; qa.classList.add('is-busy');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:1})})
      .then(function(r){ qa.classList.remove('is-busy');
        if(!r.ok){ qa.innerHTML='<span>Sold out</span>'; setTimeout(function(){ qa.innerHTML=t; },1800); return; }
        if($('#Drawer')&&$('#Drawer').classList.contains('is-on')) renderCart(); else openDrawer(); })
      .catch(function(){ qa.classList.remove('is-busy'); qa.innerHTML=t; });
    }
  });

  /* ---------- Mobile nav ---------- */
  function closeNav(){ $('#NavDrawer')&&$('#NavDrawer').classList.remove('is-on'); if(!$('#Drawer')||!$('#Drawer').classList.contains('is-on')){ $('#Overlay')&&$('#Overlay').classList.remove('is-on'); } }
  document.addEventListener('click',function(e){
    if(e.target.closest('#Burger')){ $('#NavDrawer')&&$('#NavDrawer').classList.add('is-on'); $('#Overlay')&&$('#Overlay').classList.add('is-on'); }
    if(e.target.closest('#NavClose')){ closeNav(); }
  });

  /* ---------- Announcement rotation ---------- */
  var annMsgs=$all('#FdAnn .fd-ann__msg');
  if(annMsgs.length>1 && !reduceMotion){
    var ai=0; setInterval(function(){ annMsgs[ai].classList.remove('is-on'); ai=(ai+1)%annMsgs.length; annMsgs[ai].classList.add('is-on'); },4000);
  }

  /* ---------- Header: overlay header becomes a floating bar after the hero ---------- */
  var head=$('#Head'), spacer=$('#HeadSpacer');
  if(head){
    var inFlow=!head.classList.contains('fd-head--over'), limit=inFlow?head.offsetTop+head.offsetHeight+40:160;
    var onScroll=function(){
      var stuck=window.scrollY>limit;
      if(stuck!==head.classList.contains('is-stuck')){
        if(inFlow&&spacer){ spacer.style.display=stuck?'block':'none'; spacer.style.height=stuck?(head.offsetHeight+13)+'px':'0'; }
        head.classList.toggle('is-stuck',stuck);
      }
    };
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  }

  /* ---------- Shop grid size toggle (remembered per browser) ---------- */
  var grid=$('#FdGrid'), gbtns=$all('[data-grid]');
  if(grid&&gbtns.length){
    var setGrid=function(n){ grid.classList.toggle('is-2',n==='2'); gbtns.forEach(function(b){ b.classList.toggle('is-on',b.getAttribute('data-grid')===n); }); try{ localStorage.setItem('fdGrid',n); }catch(e){} };
    gbtns.forEach(function(b){ b.addEventListener('click',function(){ setGrid(b.getAttribute('data-grid')); }); });
    try{ var saved=localStorage.getItem('fdGrid'); if(saved) setGrid(saved); }catch(e){}
  }

  /* ---------- Horizontal rails (product cards, photo row) ---------- */
  $all('[data-rail]').forEach(function(rail){
    var track=$('[data-rail-track]',rail); if(!track) return;
    var step=function(){ var c=track.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap||0) : 300; };
    var prev=$('[data-rail-prev]',rail), next=$('[data-rail-next]',rail), bar=$('[data-rail-bar]',rail), dotsEl=$('[data-rail-dots]',rail);
    if(dotsEl){
      var n=track.children.length; dotsEl.innerHTML=Array(n+1).join('<span></span>'); var ds=$all('span',dotsEl); if(ds[0]) ds[0].classList.add('is-on');
      track.addEventListener('scroll',function(){ var i=Math.round(track.scrollLeft/step()); ds.forEach(function(d,k){ d.classList.toggle('is-on',k===Math.min(i,n-1)); }); },{passive:true});
    }
    prev&&prev.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:reduceMotion?'auto':'smooth'}); });
    next&&next.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:reduceMotion?'auto':'smooth'}); });
    if(bar){
      var upd=function(){ var max=track.scrollWidth-track.clientWidth; var vis=track.clientWidth/track.scrollWidth; bar.style.width=Math.max(10,vis*100)+'%'; bar.style.transform='translateX('+(max>0?(track.scrollLeft/max)*((1/Math.max(vis,.1))-1)*100:0)+'%)'; };
      track.addEventListener('scroll',upd,{passive:true}); window.addEventListener('resize',upd); upd();
    }
  });

  /* ---------- Product page ---------- */
  var pdp=$('#Pdp');
  if(pdp && window.FD_VARIANTS){
    var variants=window.FD_VARIANTS, sel={};
    $all('[data-opt].is-active',pdp).forEach(function(b){ sel[b.getAttribute('data-opt')]=b.getAttribute('data-val'); });

    /* desktop gallery: clicking a side image shows it in the main frame */
    var mainImg=$('#FdGalMainImg'), thumbs=$all('.fd-gal__thumb');
    function showMedia(id){
      var t=thumbs.filter(function(x){return x.getAttribute('data-media-id')===String(id);})[0];
      if(t && mainImg && t.getAttribute('data-type')!=='video' && t.getAttribute('data-type')!=='external_video'){
        mainImg.style.opacity='0';
        setTimeout(function(){ mainImg.src=t.getAttribute('data-src'); mainImg.srcset=t.getAttribute('data-srcset'); mainImg.style.opacity='1'; },120);
      }
      thumbs.forEach(function(x){ x.classList.toggle('is-active',x===t); });
      var mt=$('#FdMobTrack'), slide=mt&&$('[data-media-id="'+id+'"]',mt);
      if(slide) mt.scrollTo({left:slide.offsetLeft,behavior:'auto'});
    }
    thumbs.forEach(function(t){ t.addEventListener('click',function(){ showMedia(t.getAttribute('data-media-id')); }); });
    var down=$('#FdGalDown'), list=$('#FdGalList');
    down&&list&&down.addEventListener('click',function(){ list.scrollBy({top:list.clientHeight*.8,behavior:'smooth'}); });

    /* mobile carousel dots */
    var mt=$('#FdMobTrack'), dots=$all('#FdMobDots span');
    if(mt&&dots.length){
      mt.addEventListener('scroll',function(){ var i=Math.round(mt.scrollLeft/mt.clientWidth); dots.forEach(function(d,k){ d.classList.toggle('is-on',k===i); }); },{passive:true});
    }

    /* rotating info bar */
    var infos=$all('#FdInfo .fd-info__m'), idots=$('#FdInfoDots');
    if(infos.length>1&&idots){
      idots.innerHTML=infos.map(function(_,k){return '<span'+(k===0?' class="is-on"':'')+'></span>';}).join('');
      var dd=$all('span',idots), ii=0;
      if(!reduceMotion) setInterval(function(){ infos[ii].classList.remove('is-on'); dd[ii].classList.remove('is-on'); ii=(ii+1)%infos.length; infos[ii].classList.add('is-on'); dd[ii].classList.add('is-on'); },3500);
    }

    /* side panels */
    var panel=$('#FdPanel'), scrim=$('#FdScrim'), ptitle=$('#FdPanelTitle'), lastBtn=null;
    function openPanel(key,btn){
      if(!panel) return; lastBtn=btn||null;
      $all('.fd-panel__sec',panel).forEach(function(s){ var on=s.getAttribute('data-sec')===key; s.hidden=!on; if(on&&ptitle) ptitle.textContent=s.getAttribute('data-title'); });
      panel.classList.add('is-on'); scrim&&scrim.classList.add('is-on'); document.body.style.overflow='hidden';
      var x=$('#FdPanelClose'); x&&x.focus();
    }
    function closePanel(){ if(!panel) return; panel.classList.remove('is-on'); scrim&&scrim.classList.remove('is-on'); document.body.style.overflow=''; lastBtn&&lastBtn.focus(); }
    $all('[data-panel]').forEach(function(b){ b.addEventListener('click',function(){ openPanel(b.getAttribute('data-panel'),b); }); });
    $('#FdPanelClose')&&$('#FdPanelClose').addEventListener('click',closePanel);
    scrim&&scrim.addEventListener('click',closePanel);
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&panel&&panel.classList.contains('is-on')) closePanel(); });

    /* variants */
    var atc=$('#AtcBtn'), stickyBtn=$('#StickyAtcBtn'), disp=$('#FdDispatch');
    function currentVariant(){ return variants.filter(function(v){ return v.options.every(function(val,i){ return sel[i]==null||sel[i]===val; }); })[0]; }
    function applyVariant(){
      var v=currentVariant(); if(!v) return;
      $('#VariantId').value=v.id;
      var now=$('#PriceNow'), was=$('#PriceWas');
      if(now) now.textContent=money(v.price);
      if(was){ var on=v.compare_at_price>v.price; was.style.display=on?'':'none'; if(on) was.textContent=money(v.compare_at_price); }
      var sp=$('#StickyPrice'); if(sp) sp.textContent=money(v.price);
      var sku=$('#PdpSku'); if(sku) sku.textContent=v.sku||v.id;
      if(atc){ atc.disabled=!v.available; atc.innerHTML=v.available?'Add to bag – <b id="AtcPrice">'+money(v.price)+'</b>':'Sold out'; }
      if(stickyBtn){ stickyBtn.disabled=!v.available; stickyBtn.textContent=v.available?'Add to bag':'Sold out'; }
      if(disp) disp.textContent=disp.getAttribute(v.available?'data-in':'data-out');
      if(v.featured_media&&v.featured_media.id) showMedia(v.featured_media.id);
      if(window.history&&history.replaceState){ var u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState(null,'',u.toString()); }
    }
    $all('[data-opt]',pdp).forEach(function(b){
      b.addEventListener('click',function(){
        var opt=b.getAttribute('data-opt');
        $all('[data-opt="'+opt+'"]',pdp).forEach(function(x){x.classList.remove('is-active');});
        b.classList.add('is-active'); sel[opt]=b.getAttribute('data-val');
        var lbl=$('#optval-'+opt); if(lbl) lbl.textContent=b.getAttribute('data-val');
        applyVariant();
      });
    });

    /* add to bag (AJAX + drawer); Shop Pay button submits natively */
    var form=$('#PdpForm');
    if(form) form.addEventListener('submit',function(e){
      e.preventDefault();
      if(!atc||atc.disabled) return;
      var txt=atc.innerHTML; atc.textContent='Adding…'; atc.disabled=true;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt($('#VariantId').value,10),quantity:1}]})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(){ atc.innerHTML=txt; atc.disabled=false; openDrawer(); })
      .catch(function(){ atc.textContent='Try again'; atc.disabled=false; });
    });

    /* sticky add bar (mobile) once the main button scrolls away */
    var box=$('#AtcBox'), sticky=$('#FdSticky');
    if(box&&sticky&&'IntersectionObserver' in window){
      new IntersectionObserver(function(en){ sticky.classList.toggle('is-on',!en[0].isIntersecting && en[0].boundingClientRect.top<0); },{threshold:0}).observe(box);
    }
    stickyBtn&&stickyBtn.addEventListener('click',function(){ if(!form)return; if(form.requestSubmit)form.requestSubmit(); else form.dispatchEvent(new Event('submit',{cancelable:true})); });
  }

  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ setCount(c.item_count); });
})();
